export default __webpack_public_path__ + "static/media/passage.fb975ca6.png";